import { ReactNode } from 'react'
import { BackgroundEffects } from '@/components/background-effects'

interface AppPageWrapperProps {
  children: ReactNode
  showBackground?: boolean
  backgroundOpacity?: 'subtle' | 'normal' | 'prominent'
  className?: string
}

export function AppPageWrapper({ 
  children, 
  showBackground = true, 
  backgroundOpacity = 'subtle',
  className = ''
}: AppPageWrapperProps) {
  const backgroundClasses = {
    subtle: 'opacity-30',
    normal: 'opacity-60', 
    prominent: 'opacity-100'
  }

  return (
    <div className="flex flex-col min-h-screen relative">
      {/* Background Effects - positioned behind navigation */}
      {showBackground && (
        <div className={`fixed inset-0 -z-10 ${backgroundClasses[backgroundOpacity]}`}>
          <BackgroundEffects />
        </div>
      )}
      
      {/* Main Content */}
      <div className={`relative z-0 flex-1 ${className}`}>
        {children}
      </div>
    </div>
  )
}